import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
import { Text } from '@chakra-ui/react'
import List from 'src/components/List/List'
import { Layout, Content, PageTitle } from 'src/components/Layout'
import intlMessages from './translations'
import styles from './Quotes.module.less'

class Quote extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  generateQuoteIconType = quote => {
    return quote.icon.customImage
      ? quote.icon.customImage
      : [quote.icon.fontAwesome.prefix, quote.icon.fontAwesome.iconName]
  }

  handleOptionIcon = item => {
    switch (item.id) {
      case 'auto': {
        return item.icon.type === 'default' ? ['fal', 'car'] : item.icon.customImage
      }
      case 'property': {
        return item.icon.type === 'default' ? ['fal', 'house-building'] : item.icon.customImage
      }
      case 'commercial': {
        return item.icon.type === 'default' ? ['fal', 'store'] : item.icon.customImage
      }
      case 'life': {
        return item.icon.type === 'default' ? ['fal', 'heart'] : item.icon.customImage
      }
      default: {
        return item.icon.type === 'default'
          ? ['fal', 'shield-check']
          : this.generateQuoteIconType(item)
      }
    }
  }

  getListItems = quoteOptions => {
    const { user } = this.props
    try {
      return quoteOptions.reduce((acc, item) => {
        if (
          item.isEnabled &&
          ((item.settings && item.settings.isHiddenUnlessLoggedIn && user) ||
            !item.settings.isHiddenUnlessLoggedIn)
        ) {
          acc.push({
            description: item.description,
            leftIcon: this.handleOptionIcon(item),
            leftIconType: item.icon.type,
            name: item.title,
            url:
              item.settings && item.settings.isLoginRequired && !user
                ? '/auth/login'
                : item.page.type === 'default'
                ? `/quote/get-quote/${item.id}`
                : item.page.externalUrl,
            isExternalUrl: item.page.type !== 'default',
            rightIcon: 'right',
            hideArrow: true,
          })
        }
        return acc
      }, [])
    } catch (e) {
      return []
    }
  }

  handleBack = () => {
    this.props.history.push('/')
  }

  render() {
    const { intl, quoteOptions, features } = this.props
    const foundedFeature = features.find(f => f.id == 'requestQuote')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.quoteHeader)
    const enabledOptions = quoteOptions
      ? quoteOptions.map(option => {
          return option.isEnabled
        })
      : []
    return (
      <Layout className='m-quotes-quote'>
        <Content>
          <PageTitle showBackMobile={true} title={title} />
          <div className={styles.quotesHolder + ' kiosk--chakra-colors-background'}>
            {quoteOptions && enabledOptions.every(opt => !opt) ? (
              <Text m={'20px'} fontSize={'14px'}>
                All options are disabled. Please contact your broker.{' '}
              </Text>
            ) : null}
            <List
              isOverflown={true}
              items={this.getListItems(quoteOptions)}
              styleVariationDesktop='blocks'
              attrDataQa='list-quote-types'
            />
          </div>
        </Content>
        {/* <NavBottom /> */}
      </Layout>
    )
  }
}

export default withRouter(injectIntl(Quote))
